export default function Calendar(props) {
    const { fill } = props;
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6.25 0.25V2.5H14.5V0.25H18.25V2.5H19.75V6.25H0.25V2.5H2.5V0.25H6.25Z"
                fill={fill ? fill : '#212121'}
            />
            <path
                d="M19.75 8.5H0.25V20.5H19.75V8.5Z"
                fill={fill ? fill : '#212121'}
            />
        </svg>
    );
}
